import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './styles.css';

interface IMessageImagesThreeImagesInRowLayoutProps {
  images: React.ReactElement[];
}

/**
 * Компонент верстки галереи из нескольких фото (до 3 фото в ряд)
 */
export const MessageImagesThreeImagesInRowLayout: React.VFC<IMessageImagesThreeImagesInRowLayoutProps> = ({
  images,
}) => {
  const items = React.useMemo(
    () =>
      images.map((image, index) => (
        <div key={index} className={styles['image']}>
          {image}
        </div>
      )),
    [images],
  );

  return (
    <div
      data-testid="message_images_in_row"
      {...mergeStyles(styles['gallery'], styles[`gallery--size-${items.length}`])}
    >
      {items}
    </div>
  );
};
